import React, { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ConsoleHomePageHeader from "../Home/ConsoleHomePageHeader";
import QRCode from "../TagGeneration/QRCode";
import { APP_STORE_URL, INSTAGRAM_URL } from "../../constants";

const PROMO_PDFS = [
  {
    key: "instagram",
    title: "Leaflings: Plant care",
    url: INSTAGRAM_URL,
    accent: "#d45f8c",
    fileName: "leaflings-instagram-qr",
    footerText: "@leaflings.app",
  },
  {
    key: "appstore",
    title: "Download the iPhone app",
    url: APP_STORE_URL,
    accent: "#2f8f83",
    fileName: "leaflings-app-store-qr",
    footerText: "leaflings.app",
  },
  {
    key: "venmo",
    title: "Venmo",
    url: "https://account.venmo.com/u/cristianoronaldo",
    accent: "#1683d6",
    fileName: "leaflings-venmo-qr",
    footerText: "@cristianoronaldo",
  },
];

const exportCardAsPdf = async (element, fileName) => {
  if (!element) return;

  const canvas = await html2canvas(element, {
    scale: 4,
    allowTaint: true,
    useCORS: true,
    letterRendering: true,
    backgroundColor: "#ffffff",
  });

  const image = canvas.toDataURL("image/png", 1.0);
  const pdf = new jsPDF("portrait", "mm", "letter");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const margin = 12;
  const renderWidth = pdfWidth - margin * 2;
  const renderHeight = (canvas.height * renderWidth) / canvas.width;
  const top = Math.max(margin, (pdfHeight - renderHeight) / 2);

  pdf.addImage(image, "PNG", margin, top, renderWidth, renderHeight);
  pdf.save(`${fileName}.pdf`);
};

const PromoCard = React.forwardRef(({ promo }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        width: 900,
        minHeight: 1160,
        backgroundColor: "#ffffff",
        padding: "72px 72px 64px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          fontSize: 42,
          fontWeight: 700,
          color: "#20352a",
          textAlign: "center",
          lineHeight: 1.1,
        }}
      >
        {promo.title}
      </div>
      <div
        style={{
          width: 560,
          height: 560,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          border: `6px solid ${promo.accent}`,
          borderRadius: 24,
          boxSizing: "border-box",
        }}
      >
        <div style={{ transform: "scale(6.4)", transformOrigin: "center" }}>
          <QRCode
            url={promo.url}
            backgroundColor="#ffffff"
            foregroundColor={promo.accent}
          />
        </div>
      </div>
      <div
        style={{
          fontSize: 22,
          color: "#5a675f",
          textAlign: "center",
          lineHeight: 1.2,
        }}
      >
        {promo.footerText}
      </div>
    </div>
  );
});

const PromoTagGeneration = () => {
  const refs = {
    instagram: useRef(null),
    appstore: useRef(null),
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "rgb(255, 240, 207)" }}>
      <ConsoleHomePageHeader />
      <div style={{ maxWidth: "980px", margin: "0 auto", padding: 20 }}>
        <h2 style={{ marginTop: 0 }}>Promo QR PDFs</h2>
        <p style={{ maxWidth: 640 }}>
          Export a single large QR PDF for Instagram and a single large QR PDF
          for the iPhone app.
        </p>

        <div style={{ display: "grid", gap: 28 }}>
          {PROMO_PDFS.map((promo) => (
            <section key={promo.key}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 16,
                  flexWrap: "wrap",
                  marginBottom: 12,
                }}
              >
                <h3 style={{ margin: 0 }}>{promo.title}</h3>
                <button
                  type="button"
                  className="getPlantButton"
                  onClick={() =>
                    exportCardAsPdf(refs[promo.key].current, promo.fileName)
                  }
                  style={{ backgroundColor: promo.accent }}
                >
                  Download PDF
                </button>
              </div>
              <div
                style={{
                  overflow: "auto",
                  padding: 12,
                  backgroundColor: "rgba(255,255,255,0.4)",
                  borderRadius: 12,
                }}
              >
                <PromoCard ref={refs[promo.key]} promo={promo} />
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromoTagGeneration;
